<template>
  <div id="adminproductbundles">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col>
          <ProductBundles />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import ProductBundles from "@/components/admin-components/global/ProductBundles.vue";
export default {
  name: "AdminProducts",
  components: { ProductBundles },
  data: () => ({}),
};
</script>
